import Api from '../../common/api';
import { multiPartUpload } from '@/utils';
import React from 'react';

const api = Api.getApi();

export async function requestCategoriesNestedApi(params) {
  const response = await api.request('get', '/categories/nested', {
    params: { emulate_application: params?.emulate_application },
  });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestGetCategories(params) {
  return await api.request('get', `/categories`, { params });
}

export async function requestCategoryDetailApi({ id }) {
  const response = await api.request('get', `/categories/${id}`);
  const { data } = response;
  return data;
}

export async function createCategoryApi(body) {
  return api.request('post', '/categories', { ...body });
}

export async function updateCategoryApi(categoryId, body) {
  return api.request('put', `/categories/${categoryId}`, { ...body });
}

export async function requestPatchCategory(categoryId, body) {
  return api.request('patch', `/categories/${categoryId}`, { ...body });
}

export async function updateChannelCategoryApi(categoryId, channelId, body = {}) {
  const response = await api.request('put', `/categories/${categoryId}/channels/${channelId}`, {
    ...body,
  });
  return response ? response.data : null;
}

export async function deleteCategoryApi(categoryId) {
  const response = await api.request('delete', `/categories/${categoryId}`);
  return response || null;
}

export async function requestChannelsApi({ payload }) {
  const response = await api.request('get', '/channels', { ...payload });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestCategoryTypesApi({ payload }) {
  const response = await api.request('get', '/category_types', { ...payload });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function uploadFileCategoryApi(categoryId, body) {
  const response = await api.request(
    'post',
    `/categories/${categoryId}/files`,
    { ...body },
    multiPartUpload,
  );
  return response ? response.data : null;
}

export async function deleteCategoryFilesApi(categoryId, fileId) {
  const response = await api.request('delete', `/categories/${categoryId}/files/${fileId}`);
  return response;
}

export async function updateCategoryFilesApi(categoryId, fileId, body) {
  const response = await api.request(
    'post',
    `/categories/${categoryId}/files/${fileId}`,
    body,
    multiPartUpload,
  );
  return response;
}

export async function requestCategoryFilesApi(categoryId) {
  const response = await api.request('get', `/categories/${categoryId}/files`, {
    page: 1,
    limit: 1000,
  });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestCategoryFileSubTypeApi() {
  const response = await api.request('get', `/categories/file_sub_types`);
  const { data, metadata } = response;
  return { data, metadata };
}
